import axios, { AxiosInstance } from 'axios';
import { WEB_API_URL } from 'services/constants/env';

export const backendHttp: AxiosInstance = axios.create({
	baseURL: WEB_API_URL,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});
